<template>
  <div v-if="!loading">
    <pdf-translate-visor
      v-for="(item, index) in pdfData"
      :key="`item${index}`"
      v-show="locale === item.locale"
      :url="item.url"
      :downloadPdf="data.DownloadPdfTranslate"
      :pdfTranslateLink="data.PDFTranslateLink"
      :pdfTranslateLinkName="data.PDFTranslateLinkName"
    />
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import axios from 'axios'
  import pdf from 'vue-pdf'
  import PdfTranslateVisor from './PDFTranslateVisor'
  // const demo = require('@/assets/demo.pdf')
  export default {
    components: {
      pdf,
      PdfTranslateVisor
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
      loading: true,
      url: null,

      pdfData: null,
      src: null,
      page: 1,
      numPages: null
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent', 'Color', 'BGColor']),
      languages () {
        return this.$store.state.app.Languages
      },
      sPage () {
        return `${utils.pad(this.page.toString(), this.numPages.toString().length)} / ${utils.pad(this.numPages.toString(), this.numPages.toString().length)}`
      },
      debug () {
        return this.$route.query.debug && this.$route.query.debug.length > 0
      }
    },
    watch: {
      'data.URLPdfTranslate': {
        handler: function (newValue) {
          // this.loadPDF(newValue)
          if (this.data.URLPdfTranslate) this.loadPDFData(newValue)
          // this.url = this.prepareURL(newValue)
        },
        deep: true
      },
    },
    mounted() {
      if (this.data.URLPdfTranslate) this.loadPDFData(this.data.URLPdfTranslate)
      // if (this.data.URLPdfTranslate) this.url = this.prepareURL(this.data.URLPdfTranslate)//this.loadPDF(this.data.URLPdfTranslate)
    },
    methods: {
      errorPDF (error) {
        console.log(error)
      },
      loadPDFData (value) {
        this.loading = true
        if (value) {
          const aux = []
          for (const lng of this.languages) {
            aux.push({
              url: utils.getTranslation(value, lng),
              locale: lng
            })
          }
          this.pdfData = aux
        }
        this.loading = false
      },
      // loadPDF (value) {
      //   this.loading = true
      //   if (value) {
      //     this.pdfData = {}
      //     for (const lng of this.languages) {
      //       this.pdfData[lng] = {}          
      //       this.pdfData[lng].url = utils.getTranslation(value, lng)
      //       this.pdfData[lng].src = pdf.createLoadingTask(`${this.pdfData[lng].url}`)
      //       const that = this
      //       this.pdfData[lng].src.then(pdf => {
      //         that.pdfData[lng].numPages = pdf.numPages
      //         that.pdfData[lng].page = 1
      //       })
      //     }
      //   }
      //   this.loading = false
      //   console.log(this.loading, this.pdfData)
      //   // if (this.src) this.src.destroy()
      //   // this.src = pdf.createLoadingTask(`${value}`)
      //   // this.src.then(pdf => {
      //   //   console.log(pdf)
      //   //   this.numPages = pdf.numPages
      //   //   this.page = 1
      //   // })
      // },
      // prepareURL (url) {        
      //   const result = utils.getTranslation(url, this.locale)
      //   this.url = result
      //   return result
      // },
      // handleChangePage (value) {
      //   this.page = (this.page + value) > 0 && (this.page + value) <= this.numPages ? this.page + value : this.page
      // },
      // handleDownloadPDF () {
      //   axios({
      //     method: 'get',
      //     url: this.url,
      //     responseType: 'arraybuffer'
      //   })
      //   .then(response => {
      //     this.forceFileDownload(response)
      //   })
      //   .catch(() => console.log('error occured'))
      // },
      // forceFileDownload(response){
      //   const url = window.URL.createObjectURL(new Blob([response.data]))
      //   const link = document.createElement('a')
      //   link.href = url
      //   link.setAttribute('download', 'file.pdf') //or any other extension
      //   document.body.appendChild(link)
      //   link.click()
      // },
    }
  }
</script>

<style lang="scss" scoped>
  .video-responsive {
    position: relative;
    padding-bottom: 56.25%; /* 16/9 ratio */
    padding-top: 30px; /* IE6 workaround*/
    height: 0;
    overflow: hidden;
  }

  .video-responsive iframe,
  .video-responsive object,
  .video-responsive embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
